import axios from "axios";
import { getIncomingReferral } from "@/lib/referral";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitEmailSignup = (email, source = "homepage") => {
  const referrer_code = getIncomingReferral();
  return api
    .post("/email-signups", { email, source, referrer_code })
    .then((r) => r.data);
};

export const submitCommunityPhoto = (data) =>
  api.post("/community-submissions", data).then((r) => r.data);

export const submitContactForm = (data) =>
  api.post("/contact", data).then((r) => r.data);

// --- Rider Feedback Hub -----------------------------------------------------
export const submitFeedback = (data) =>
  api.post("/feedback", data).then((r) => r.data);

const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const listFeedback = (token, params = {}) =>
  api.get("/feedback", { ...adminHeaders(token), params }).then((r) => r.data);

export const updateFeedback = (token, id, patch) =>
  api.patch(`/feedback/${id}`, patch, adminHeaders(token)).then((r) => r.data);

export const deleteFeedback = (token, id) =>
  api.delete(`/feedback/${id}`, adminHeaders(token)).then((r) => r.data);

export const listFeatureRequests = (token) =>
  api.get("/feature-requests", adminHeaders(token)).then((r) => r.data);

export const updateFeatureRequest = (token, id, patch) =>
  api.patch(`/feature-requests/${id}`, patch, adminHeaders(token)).then((r) => r.data);

export const reclusterFeedback = (token) =>
  api.post("/feature-requests/recluster", null, adminHeaders(token)).then((r) => r.data);
